import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ADD_COLUMN } from '../../util/enums/EnumLayers';
import { validateExpression } from '../../actions';

class ModalAddColumn extends Component {
  static modalType() {
    return ADD_COLUMN;
  }

  static reducer(modals) {
    return modals.addColumnModal;
  }

  static title() {
    return (
      <span>
        <span
          className="glyphicon glyphicon-plus margin-right-10"
          aria-hidden="true"
        />
        Add a new column
      </span>
    );
  }

  componentDidMount() {
    setTimeout(() => {
      if (this._input) {
        this._input.select();
      }
    }, 500);
  }

  render() {
    const { userInteraction, state, columns, onExpressionChanged } = this.props;

    function selectionChange(e) {
      if (e.target.selectionStart) {
        userInteraction({
          section: 'cursor-pos',
          position: e.target.selectionStart,
        })();
      }
    }
    const textFieldChanged = (section) => (e) => {
      const props = {
        section,
        newValue: e.target.value,
        columns,
      };
      userInteraction(props)();
      if (
        section === 'expression-changed' &&
        e.target.value.trim().length > 0
      ) {
        onExpressionChanged(columns, e.target.value, state.replaceExisting);
      }
    };
    const columnOptionClicked = (columnName) => () => {
      userInteraction({ section: 'column-option', columnName })();
      this._expression.focus();
      setTimeout(() => {
        onExpressionChanged(
          columns,
          this._expression.value,
          state.replaceExisting,
        );
      }, 500);
    };

    const columnOptions = columns.map((c) => {
      return (
        <button
          key={c.name().toString()}
          type="button"
          onClick={columnOptionClicked(c.name())}
          className="btn btn-outline-dark btn-sm margin-horizontal faint click-to-add-column"
        >
          {c.name().toString()}
        </button>
      );
    });

    const nameError = state.nameError ? (
      <div className="alert alert-danger" role="alert">
        {state.nameError}
      </div>
    ) : null;
    const errorMsg = state.expressionErrorMsg && (
      <div className="alert alert-danger" role="alert">
        {state.expressionErrorMsg}
      </div>
    );
    const toggleCheckbox = () => {
      userInteraction({ section: 'toggleReplaceExisting', columns })();
      onExpressionChanged(columns, state.expression, !state.replaceExisting);
    };
    return (
      <table className="full-width">
        <tbody>
          <tr>
            <td colSpan="4" className="vertical-align-center">
              {state.replaceExisting ? null : <label>Name your column</label>}
              <label className="pull-right user-clickable">
                <input
                  type="checkbox"
                  checked={state.replaceExisting}
                  onChange={toggleCheckbox}
                />
                <span className="margin-left-5">
                  Or, replace existing column
                </span>
              </label>
            </td>
          </tr>
          {state.replaceExisting ? null : (
            <tr>
              <td colSpan="4">
                <input
                  placeholder="my_column"
                  className="form-control set-input-height"
                  onChange={textFieldChanged('name-changed')}
                  value={state.name}
                  ref={(input) => (this._input = input)}
                />
              </td>
            </tr>
          )}
          <tr>
            <td colSpan="4">{nameError}</td>
          </tr>
          <tr>
            <td colSpan="4" className="vertical-align-center">
              <label>
                Enter your formula{' '}
                <span className="learn-more">
                  <a
                    href="https://guide.trevor.io/hc/en-us/articles/6236441417501-Custom-column-cheatsheet"
                    target="_blank"
                  >
                    View cheat sheet
                  </a>
                </span>
              </label>
            </td>
          </tr>
          <tr>
            <td colSpan="4">
              <textarea
                data-gramm="false"
                placeholder="(5 / 23) * 100"
                className="form-control custom-expression-area"
                onChange={textFieldChanged('expression-changed')}
                value={state.expression}
                onClick={selectionChange}
                onKeyUp={selectionChange}
                ref={(input) => (this._expression = input)}
              />
            </td>
          </tr>
          <tr>
            <td colSpan="4">
              <p className="faint">
                Trevor supports a range of formulas and functions, from basic
                arithmetic to more advanced custom expressions.&nbsp;
                <b className="not-faint">Click the columns below</b> to include
                them in your expression.
              </p>
              {columnOptions}
            </td>
          </tr>
          <tr>
            <td colSpan="4">{errorMsg}</td>
          </tr>
        </tbody>
      </table>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onExpressionChanged: (columns, expressionValue, replaceExisting) => {
      dispatch(validateExpression(columns, expressionValue, replaceExisting));
    },
  };
};

export default connect(null, mapDispatchToProps)(ModalAddColumn);
